var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.666 27.6663H13.3327C6.89268 27.6663 1.66602 22.4263 1.66602 15.9997C1.66602 9.57301 6.89268 4.33301 13.3327 4.33301H18.666C25.106 4.33301 30.3327 9.57301 30.3327 15.9997C30.3327 22.4263 25.106 27.6663 18.666 27.6663ZM13.3327 6.33301C7.99935 6.33301 3.66602 10.6663 3.66602 15.9997C3.66602 21.333 7.99935 25.6663 13.3327 25.6663H18.666C23.9993 25.6663 28.3327 21.333 28.3327 15.9997C28.3327 10.6663 23.9993 6.33301 18.666 6.33301H13.3327Z",
    fill: "#3D48E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6654 22.3337C15.172 22.3337 12.332 19.4937 12.332 16.0003C12.332 12.507 15.172 9.66699 18.6654 9.66699C22.1587 9.66699 24.9987 12.507 24.9987 16.0003C24.9987 19.4937 22.1587 22.3337 18.6654 22.3337ZM18.6654 11.667C16.2787 11.667 14.332 13.6137 14.332 16.0003C14.332 18.387 16.2787 20.3337 18.6654 20.3337C21.052 20.3337 22.9987 18.387 22.9987 16.0003C22.9987 13.6137 21.052 11.667 18.6654 11.667Z",
    fill: "#3D48E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio);
export default __webpack_public_path__ + "static/media/radio.46d9a339841a13bbea1f494d04e7c7d6.svg";
export { ForwardRef as ReactComponent };